import React from 'react'
// import spinner from '../components/spinner'
import Spinner from '../components/Spinner'
import Copyright from '../components/Copyright'
import BacktoTop from '../components/BacktoTop'
import Footer from '../components/Footer'
import Testimonial from '../components/Testimonial'
import Team from '../components/Team' 
import Blog from '../components/Blog' 
import Products from '../components/Products'
import Service from '../components/Service'
import Programs from '../components/Programs'
import FactsCounter from '../components/FactsCounter'
import About from '../components/About'
import Projects from '../components/Projects'
import SearchModal from '../components/SearchModal'
import PartnersSlider from '../components/PartnersSlider'
import HeroAndNavbar from '../components/HeroAndNavbar'
import TopBar from '../components/TopBar'
import SevenYearModel from '../components/SevenYearModel'
import GrassrootForAfrica from '../components/GrassrootForAfrica'
import PHGInPictures from '../components/PHGInPictures'
import AbroadMERBLI from '../components/AbroadMERBLI'

const HomePage = () => {
  return (
    <body>
      {/* <Spinner /> */}
      <TopBar />
      <HeroAndNavbar />
      <PartnersSlider />
      <SearchModal />
      <PHGInPictures />
      <Projects />
      <About />
      <FactsCounter />
      <GrassrootForAfrica />
      <SevenYearModel />
      <AbroadMERBLI />
      <Programs />
      {/* <Service / > */}
      {/* <Products /> */}
      <Blog />
      <Team />
      {/* <Testimonial /> */}
      <Footer />
      <Copyright />
      <BacktoTop />
    </body>
  )
}

export default HomePage